// root index
import React from 'react';
import ReactDOM from 'react-dom';
import App from './component/App';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createStore from './store.js';
import ScrollToTop from './component/ScrollToTop';
import MuiTheme from './component/MuiTheme';
import { MuiThemeProvider } from 'material-ui/styles';
import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory();
const store = createStore(history);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history} >
      <MuiThemeProvider theme={MuiTheme} >
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </MuiThemeProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js